import { RadioAsButton as a } from "../RadioAsButton/RadioAsButton.js";
import '../assets/AscDesc.css';const n = "op_Icon_pZj9U", t = {
  Icon: n
};
function l(e) {
  return e.value == null && e.currentValue == null ? null : /* @__PURE__ */ React.createElement(
    a,
    {
      choices: [
        { label: [/* @__PURE__ */ React.createElement(React.Fragment, null, "ASC", /* @__PURE__ */ React.createElement("span", { className: t.Icon }, "↑"))], value: "ASC" },
        { label: [/* @__PURE__ */ React.createElement(React.Fragment, null, "DESC", /* @__PURE__ */ React.createElement("span", { className: t.Icon }, "↓"))], value: "DESC" }
      ],
      inputAttri: { ...e.inputAttri, name: "order" },
      value: e.value ?? e.currentValue
    }
  );
}
export {
  l as AscDesc
};
